export default __webpack_public_path__ + "static/media/add.33cd31d8.svg";